import {
  LayoutDashboard,
  Users,
  Building2,
  Briefcase,
  Settings,
  Focus,
  LogOut
} from 'lucide-react';

export const navigation = [
  // Top section
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  {
    name: 'Focus',
    icon: Focus,
    children: [
      { name: 'Break the Ice', href: '/focus/break-the-ice' },
      { name: 'Ice Broken', href: '/focus/ice-broken' },
      { name: 'Follow Ups', href: '/focus/follow-ups' },
    ],
  },
  { name: 'Contacts', href: '/contacts', icon: Users },
  { name: 'Companies', href: '/companies', icon: Building2 },
  { name: 'Opportunities', href: '/jobs', icon: Briefcase },
  
  // Bottom section
  { name: 'Settings', href: '/settings', icon: Settings, isBottom: true },
  { name: 'Sign Out', icon: LogOut, isBottom: true, action: 'signOut' },
]; 